import React from 'react'
import { PARTICIPANT_COLORS, hashString } from './participantColors.js'
import { BotIcon } from './icons.jsx'
import './ContactList.css'

export const ContactList = ({
  contacts,
  onSelectContact,
  selectedContactId,
}) => {
  const online = contacts.filter(c => c.online)
  const offline = contacts.filter(c => !c.online)

  if (contacts.length === 0) {
    return (
      <div className="contact-empty">
        <BotIcon size={40} color="var(--text-dim)" />
        <p className="contact-empty-text">No contacts</p>
        <p className="contact-empty-hint">Bots will appear here when registered</p>
      </div>
    )
  }

  return (
    <div className="contact-list">
      {online.length > 0 && (
        <div className="contact-section">
          <div className="contact-section-title">Online</div>
          {online.map(c => {
            const color = PARTICIPANT_COLORS[hashString(c.roleId) % PARTICIPANT_COLORS.length]
            const selected = selectedContactId === c.roleId
            return (
              <div key={c.roleId} className={`contact-item contact-item-online${selected ? ' contact-item-selected' : ''}`} onClick={() => onSelectContact(c)}>
                <div className="contact-avatar" style={{ background: `linear-gradient(135deg, ${color}22, ${color}11)` }}>
                  <BotIcon color={color} />
                  <span className="contact-status online" />
                </div>
                <div className="contact-info">
                  <div className="contact-name">
                    {c.displayName}
                    {c.typeName && c.displayName !== c.typeName && <span className="contact-type"> ({c.typeName})</span>}
                  </div>
                  {c.description && <div className="contact-desc">{c.description}</div>}
                </div>
              </div>
            )
          })}
        </div>
      )}
      {offline.length > 0 && (
        <div className="contact-section">
          <div className="contact-section-title">Offline</div>
          {offline.map(c => {
            const color = PARTICIPANT_COLORS[hashString(c.roleId) % PARTICIPANT_COLORS.length]
            const selected = selectedContactId === c.roleId
            return (
              <div key={c.roleId} className={`contact-item contact-item-offline${selected ? ' contact-item-selected' : ''}`} onClick={() => onSelectContact(c)}>
                <div className="contact-avatar" style={{ background: `linear-gradient(135deg, ${color}22, ${color}11)` }}>
                  <BotIcon color="var(--text-tertiary)" />
                  <span className="contact-status offline" />
                </div>
                <div className="contact-info">
                  <div className="contact-name">{c.displayName}</div>
                </div>
              </div>
            )
          })}
        </div>
      )}
    </div>
  )
}
